import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ReactComponent as PlayIcon } from "../../static/svg/play-btn-new.svg";
import { ReactComponent as HomeFrontIcon } from "../../static/svg/brand/homefront-logo.svg";
import { ReactComponent as PodcastBg } from "../../static/svg/backgrounds/podcast-bg.svg";
import { ReactComponent as YoutubeIcon } from "../../static/svg/youtube.svg";
import { ReactComponent as SpotifyIcon } from "../../static/svg/spotify.svg";

import LatestPodcastCard from "./LatestPodcastCard";
import MHButton from "../Common/Button/MHButton";
import { useHistory } from "react-router-dom";
import { ResourcesData } from "./EventGlance";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import AnimatedLoaderText from "../Common/Loading/AnimatedLoaderText";
import dayjs from "dayjs";

type Props = {};

// const events = [
//   {
//     date: "March 2026",
//     title: "Welcome To The Homefront: A Caring Africa Podcast",
//     tags: "Ep 01",
//     length: "4 min",
//     imageUrl:
//       "https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg",
//   },
//   {
//     date: "March 2026",
//     title: "Who Is Watching the Children? The Childcare Crisis in Nigeria",
//     tags: "Ep 02",
//     length: "40 min",
//     imageUrl:
//       "https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg",
//   },
//   {
//     date: "March 2026",
//     title: "Naija Moms - Neglected And Overworked?",
//     tags: "Ep 03",
//     length: "49 min",
//     imageUrl:
//       "https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg",
//   },
// ];

const LatestPodcast = (props: Props) => {
  const history = useHistory(); // ← add
  const [podcastData, setPodcastData] = useState<ResourcesData[]>([]); // ← fix
  const fewPodcasts = podcastData.slice(0, 3);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const collectionRef = collection(db, "caf-podcast-list");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData), // ← fix
        }));
        setPodcastData(data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // console.log("fewPodcasts", fewPodcasts);

  if (!fewPodcasts?.length)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          borderRadius: "12px",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "100%", sm: "100%", md: "700px" },
          overflow: "hidden",
          bgcolor: "#817EB9",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6.2}
          sx={{
            position: "relative",
            minHeight: { xs: "400px", sm: "500px", md: "700px" },
          }}
        >
          <Box
            className="card-bg"
            sx={{
              backgroundImage: `url("https://mh-resources-production.s3.us-west-1.amazonaws.com/blessingAdesiyan.png")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "transform 0.5s ease",
              position: "absolute",
              inset: 0,
            }}
          />

          <Typography
            variant="caption"
            fontSize={{ xs: "10px", sm: "10px", md: "12px" }}
            lineHeight={{ xs: "80%", sm: "189%" }}
            letterSpacing={"0.1em"}
            color={"white"}
            className=" uppercase text-start w-[90%] md:w-[70%] lg:w-[90%] absolute top-[10%] left-[10%]"
          >
            Host: Blessing Oyeleye Adesiyan{" "}
          </Typography>

          <PlayIcon
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer"
            onClick={() => window.open("/podcasts")}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={5.8}
          py={{ xs: 2, sm: 4, md: 0 }}
          px={{ xs: 2, sm: 4 }}
          //   display="block"
          //   justifyContent="center"
          sx={{
            position: "relative",
            overflow: "hidden", // 👈 IMPORTANT FIX
          }}
        >
          <PodcastBg
            style={{
              position: "absolute",
              top: "50%",
              left: 0,
              transform: "translateY(-50%)",
              pointerEvents: "none",
              zIndex: 0,
            }}
          />

          <HomeFrontIcon />
          <Typography
            variant="h2"
            fontSize={{ xs: "28px", sm: "34px", md: "40px" }}
            lineHeight={{ xs: "103%", sm: "105.5%" }}
            letterSpacing="-0.05em"
            align="left"
            color={"white"}
            className="py-4"
          >
            Tune in To The <br /> Home Front Podcast{" "}
          </Typography>
          <Typography
            variant="subtitle1"
            fontSize={{ xs: "12px", sm: "14px", md: "14px" }}
            lineHeight={{ xs: "185%", sm: "180%" }}
            letterSpacing={"-0.02em"}
            color={"white"}
            className=" text-start w-[90%] md:w-[70%] lg:w-[70%]"
          >
            Conversations on care, policy, and community-building throughout
            Africa
          </Typography>

          <Box display="flex" flexDirection="column" width="100%">
            {fewPodcasts &&
              fewPodcasts?.map((podcast, i) => (
                <LatestPodcastCard
                  key={i}
                  date={dayjs(podcast.releaseDate).format("MMMM YYYY")}
                  title={podcast.title}
                  episodeNo={Number(podcast.episodeNo)}
                  length={podcast.length}
                  imageUrl={
                    podcast.imgSrc ||
                    "https://mh-resources-production.s3.us-west-1.amazonaws.com/caf_podcast.jpg"
                  }
                  onClick={() => history.push(`/podcasts/${podcast.slug}`)}
                />
              ))}
          </Box>

          <Box
            display={{ xs: "grid", sm: "flex" }}
            justifyContent="center"
            mt={3}
            gap={2}
            className="mx-auto"
          >
            <Box>
              <MHButton
                onClick={() =>
                  window.open(
                    "https://open.spotify.com/show/43MizJhEeMXjPQG2afWoxR",
                    "_blank",
                  )
                }
                sx={{
                  color: "primary.main",
                  backgroundColor: "#fff",
                  borderRadius: "36px",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "primary.main",
                  },
                }}
                startIcon={<SpotifyIcon />}
                className="w-full md:w-[250px] h-10 md:h-[45px] font-areaExt text-[10px] md:text-xs"
              >
                Listen on Spotify
              </MHButton>
            </Box>
            <Box>
              <MHButton
                onClick={() =>
                  window.open(
                    "https://youtube.com/playlist?list=PLhQkIzHrjgtF4XHgnYW5QEs-vts6Etkax&si=iu2c4EWZ7Rx2lWub",
                    "_blank",
                  )
                }
                sx={{
                  color: "primary.main",
                  backgroundColor: "#fff",
                  borderRadius: "36px",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "primary.main",
                  },
                }}
                startIcon={<YoutubeIcon />}
                className="w-full md:w-[250px] h-10 md:h-[45px] font-areaExt text-[10px] md:text-xs"
              >
                Watch on YouTube
              </MHButton>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default LatestPodcast;
